import { render, staticRenderFns } from "./index.vue?vue&type=template&id=72d1dd4e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=72d1dd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1dd4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d1dd4e')) {
      api.createRecord('72d1dd4e', component.options)
    } else {
      api.reload('72d1dd4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=72d1dd4e&scoped=true&", function () {
      api.rerender('72d1dd4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/sheet-to-review/index.vue"
export default component.exports